module.exports = __webpack_public_path__ + "static/playback-speed-9f93bac5d18d88c3648de95ada2ea11f.png";